import http from '../../../utils/tools/http';

import {
  TOPIC_ADD_CLUE_BY_NET_SCHOOL_BEGIN,
  TOPIC_ADD_CLUE_BY_NET_SCHOOL_SUCCESS,
  TOPIC_ADD_CLUE_BY_NET_SCHOOL_FAILURE,
  TOPIC_ADD_CLUE_BY_NET_SCHOOL_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function addClueByNetSchool(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: TOPIC_ADD_CLUE_BY_NET_SCHOOL_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
        const doRequest = http.post({ url: "/crm/Clue/AddClueByNetSchool", params: args });
      doRequest.then(
        (res) => {
          dispatch({
            type: TOPIC_ADD_CLUE_BY_NET_SCHOOL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: TOPIC_ADD_CLUE_BY_NET_SCHOOL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissAddClueByNetSchoolError() {
  return {
    type: TOPIC_ADD_CLUE_BY_NET_SCHOOL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TOPIC_ADD_CLUE_BY_NET_SCHOOL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        addClueByNetSchoolPending: true,
        addClueByNetSchoolError: null,
      };

    case TOPIC_ADD_CLUE_BY_NET_SCHOOL_SUCCESS:
      // The request is success
      return {
        ...state,
        addClueByNetSchoolPending: false,
        addClueByNetSchoolError: null,
      };

    case TOPIC_ADD_CLUE_BY_NET_SCHOOL_FAILURE:
      // The request is failed
      return {
        ...state,
        addClueByNetSchoolPending: false,
        addClueByNetSchoolError: action.data.error,
      };

    case TOPIC_ADD_CLUE_BY_NET_SCHOOL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        addClueByNetSchoolError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/topic/redux/addClueByNetSchool.js